import processApiResponse from "lib/process-api-response"
import sendConventionApiRequest from "lib/send-convention-api-request"

interface ConventionVideoViewCount {
  convention_video_id: string
  id: string
  video_count: number
  _type: "convention_video_count"
}

// @ts-ignore PT - #180597146
export async function getConventionVideoViewCountsList(current, query?: string) {
  const response = await sendConventionApiRequest({
    current,
    method: "GET",
    url: `v1/convention_providers/${current.provider.id}/convention_video_counts${
      query ? `?${query}` : ""
    }`,
  })
  return await processApiResponse<ConventionVideoViewCount[]>(response)
}

export async function getConventionVideoViewCountsMap(
  // @ts-ignore PT - #180597146
  current,
  query?: string,
): Promise<Record<string, number>> {
  const response = await getConventionVideoViewCountsList(current, query)
  return response.reduce((previousValue, currentValue) => {
    // @ts-ignore PT - #180597146
    previousValue[currentValue.convention_video_id] = currentValue.video_count
    return previousValue
  }, {})
}
